import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format, max, parse } from 'date-fns';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import axios, { all } from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ShubhamImage from '../../assest/images/Shubham1.png';
import Icon8 from '../../assest/images/Icon8.png'
import { useContext } from 'react';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';
import CustomSingleValue from '../common/CustomSingleValue';

const OrderReport = () => {
    const initialFromDate = new Date();
    initialFromDate.setMonth(initialFromDate.getMonth() - 1); // Set date one month ago
    const [selectedProductName, setSelectedProductName] = useState(null);
    const [selectedFromDate, setSelectedFromDate] = useState(format(initialFromDate, 'dd/MM/yyyy'));
    const [selectedToDate, setSelectedToDate] = useState(format(new Date(), 'dd/MM/yyyy'));

    const [productNames, setProductNames] = useState([]);
    const [auditData, setAuditData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedOrderType, setSelectedOrderType] = useState(null);
    const [selectedscpName, setselectedscpName] = useState(''); // Initially null for "All"
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);

    const tableRef = useRef(null);
    const [fdate, setfdate] = useState(selectedFromDate);
    const [tdate, settdate] = useState(selectedToDate);
    const [ordtype, setordtype] = useState(selectedOrderType);
    const [prname, setprname] = useState(selectedProductName);
    const [scpoptions, setscpoptions] = useState();
    const [key, setKey] = useState(0);
    const [Scps, setScps] = useState();
    const [showOrderTypeValidation, setShowOrderTypeValidation] = useState(false);
    const [isLoading,setIsLoadig] = useState(false)

    const handleChangeProductName = (selectedOption) => {
        setSelectedProductName(selectedOption ? selectedOption.value : null);
        setprname(selectedOption ? selectedOption.value : null);
    };

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);

    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);
    const customFilter = (option, searchText) => {
        if (
            option.label.toLowerCase().includes(searchText.toLowerCase()) ||
            option.data.code.toLowerCase().includes(searchText.toLowerCase())
        ) {
            return true;
        }
        return false;
    };
    const optionsproduct = [
        { value: null, label: 'All', code: '' },
        ...productNames.map(group => ({
            label: group.PL_ProductName,
            value: group.PL_ProductId,
            code: group.PL_ProductCode
        }))
    ];
    const handleFromDateChange = (date) => {
        setSelectedFromDate(format(date, 'dd/MM/yyyy'));
        setfdate(format(date, 'dd/MM/yyyy'))
    };
    const handleToDateChange = (date) => {
        setSelectedToDate(format(date, 'dd/MM/yyyy'));
        settdate(format(date, 'dd/MM/yyyy'));
    };
    const handleKeyDown = (event) => {
        event.preventDefault();
    };
    const orderoption = [
        {
            value: "Received",
            label: "Received"
        }, {
            value: "Created",
            label: "Created"
        }
    ];
    const handlescpChange = (selectedOption) => {
        console.log(selectedOption)
        setselectedscpName(selectedOption?.value || null);
    };
    useEffect(() => {
        fetch(`${config.API_URL}/productnames/${UM_CompanyID}`)
            .then(response => response.json())
            .then(data => {
                setProductNames(data.PL_ProductName);
            })
            .catch(error => console.error('Error fetching product names:', error));
    }, [selectedScpId]);



    const handleSearch = async () => {
        // Show validation for Order Type
        setShowOrderTypeValidation(true);

        // Check if Order Type is not selected
        if (!selectedOrderType) {
            toast.error('Order Type is required.');
            return; // Exit function early if validation fails
        }
        // Convert selectedFromDate and selectedToDate to Date objects for comparison
        const fromDate = parse(selectedFromDate, 'dd/MM/yyyy', new Date());
        const toDate = parse(selectedToDate, 'dd/MM/yyyy', new Date());
        // Compare dates
        if (fromDate > toDate) {
            // Show toast message indicating the error
            toast.error('From Date cannot be greater than To Date.');
            return; // Exit function early if there's an error
        }

        console.log("FROM", selectedFromDate);
        console.log("to", selectedToDate);
        console.log("scp", selectedscpName);
        console.log("prname", selectedProductName);
        console.log("tye", selectedOrderType)
        if (selectedscpName === '') {
            setselectedscpName("ALL")
        }
        console.log(selectedscpName)
        setLoading(true); // Set loading state to true before API call
        try {
            const response = await axios.post(`${config.API_URL}/report/orders`, {
                fromdate: selectedFromDate,
                todate: selectedToDate,
                scp: (selectedscpName === '') ? "ALL" : selectedscpName || 'ALL',
                dscp: selectedScpId || '',
                type: selectedOrderType || '',
                ORDIT_ProductID: (selectedProductName === null) ? "ALL" : selectedProductName || 'ALL'
            });
            console.log(response.data);
            setAuditData(response.data); // Assuming setAuditData is a state setter function
            setCurrentPage(1);

        } catch (error) {
            toast.error('Error fetching data.');
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Reset loading state after API call completes
        }
    };
    const formatDate = (dateString) => {
        return format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss');
    };

   const formatDateOnly = (dateString) =>{
    return format(new Date(dateString),'dd/MM/yyyy')
   }


    //=========== To change The date type or to remove the Time Only======
    //     const formatDate = (dateString) => {
    //   const date = new Date(dateString);
    //   if (isNaN(date)) return 'Invalid Date';
    //   return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
    // };
    //====================================================================
    // Function to group orders by ORDM_OrderNumber
    console.log(Scps)
    const handletypechange = async (selectedOption) => {
        setselectedscpName('');
        setSelectedProductName(null);
        setKey(prevKey => prevKey + 1);

        // Reset validation when Order Type is selected
        if (selectedOption && selectedOption.value) {
            setShowOrderTypeValidation(false);
        }
        try {
            setSelectedOrderType(selectedOption.value);
            setordtype(selectedOption.value);
            const response = await fetch(`${config.API_URL}/OrdReport/scp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ type: selectedOption.value, SCPID: selectedScpId })
            });
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();
            console.log(data);
            setScps(data);
            setscpoptions([{ value: '', label: 'All' }, ...data.map(type => ({
                value: type.SCPMO_SCPM_ID,
                label: type.SCPM_Name
            }))]);

        } catch (error) {
            console.error(error.message);
        }
    };
    const groupOrders = () => {
        const groupedOrders = auditData.reduce((groups, order) => {
            const key = order.ORDM_OrderNumber;
            if (!groups[key]) {
                groups[key] = [];
            }
            groups[key].push(order);
            return groups;
        }, {});
        for (let i = 0; i < groupOrders.length; i++) {
            console.log(groupOrders[i])
        }
        return groupedOrders;
    };
    const groupedAuditData = groupOrders();
    const pdfOrderData = groupOrders();
    console.log(pdfOrderData)

    const generatePDF = async () => {
        const doc = new jsPDF('landscape'); // Keep landscape orientation
        //const imgData = ShubhamImage;
        const logoRes = await fetch(`${config.API_URL}/logo-base64/${UM_CompanyGrpID}`);
        const logoJson = await logoRes.json();
        const imgData = logoJson.base64 || ShubhamImage;
        doc.addImage(imgData, 'PNG', 10, 10, 40, 20);

        const date = new Date();
        const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;

        const startX = doc.internal.pageSize.getWidth() - 50;
        const startY = 20;
        const colonOffset = 14.5;
        const valueOffset = 16.5;

        doc.setFontSize(8);
        doc.text("Printed On", startX, startY, { align: "left" });
        doc.text(":", startX + colonOffset, startY);
        doc.text(formattedDate, startX + valueOffset, startY);

        doc.text("Printed By", startX, startY + 5, { align: "left" });
        doc.text(":", startX + colonOffset, startY + 5);
        doc.text(UM_UserCode, startX + valueOffset, startY + 5);


        const tableColumn = ["Sr. No.", "Order Number", "Order Date", "From", "To", "Name", "Code", "Quantity", "Order Type", "Created Date & Time"];
        const tableRows = [];

        auditData.forEach((order, index) => {
            const orderData = [
                `${index + 1}`,
                order.ORDM_OrderNumber,
                formatDateOnly(order.ORDM_OrderDate),
                order.FromSCPM_Name,
                order.ToSCPM_Name,
                optionsproduct.find(option => option.value === order.ORDIT_ProductID)?.label || 'N/A',
                optionsproduct.find(option => option.value === order.ORDIT_ProductID)?.code || 'N/A',
                order.ORDIT_OrderQTY,
                (order.ORDM_Type === 1) ? "New Order" : "Sampling",
                formatDate(order.ORDIT_CreatedTimestamp),
            ];
            tableRows.push(orderData);
        });

        const styles = {
            detailsTable: {
                fontSize: 10,
                color: [0, 0, 0],
                margin: { top: 10 },
                fillColor: [255, 255, 255],
            },
            tableHeader: {
                fillColor: [41, 128, 185],
                textColor: [255, 255, 255],
                fontSize: 12,
                fontStyle: 'bold',
                valign: 'middle',
                halign: 'left',
                cellPadding: 2
            },
            tableRow: {
                fontSize: 10,
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
                valign: 'middle',
                halign: 'left',
                cellPadding: 2
            },
        };

        const criteria = [[{
            content: `Selected Criteria :- From : ${fdate} , To : ${tdate} , Order Type : ${selectedOrderType} , Product Name : ${(selectedProductName) === null ? "All" : optionsproduct.find(option => option.value === selectedProductName)?.label || 'N/A'}, Scp : ${(selectedscpName === "ALL") ? "ALL" : (selectedscpName === null) ? "ALL" : scpoptions.find(option => option.value === selectedscpName).label}`,
            colSpan: 10,
            styles: { fontStyle: 'bold', fontSize: 10, halign: 'left', textColor: [0, 0, 0], fillColor: [230, 240, 255] }
        }]];

        doc.autoTable({
            head: [],
            body: criteria,
            startY: startY + 15,
            theme: 'plain',
            styles: { cellPadding: 2, halign: 'left', fontSize: 10 },
        });

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: doc.lastAutoTable.finalY + 5,
            theme: 'grid',
            headStyles: styles.tableHeader,
            styles: styles.tableRow,
            alternateRowStyles: { fillColor: [255, 255, 255] },
        });

        const tableY1 = doc.lastAutoTable.finalY + 10;

        const lastsign = [
            [
                { content: `` },
                { content: `Date` },
                { content: `Sign` },
            ],
            [
                { content: `Checked By :` },
                { content: `....................` },
                { content: `....................` },
            ],
            [
                { content: `  Verified By :` },
                { content: `....................` },
                { content: `....................` },
            ],
        ];

        doc.autoTable({
            head: [],
            body: lastsign,
            startY: tableY1,
            styles: {
                textColor: [0, 0, 0],
            },
            didDrawPage: () => {
                addFooter(doc);   // Footer applied to all pages
            }
        });



        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            const pageHeight = doc.internal.pageSize.getHeight();
            const pageWidth = doc.internal.pageSize.getWidth();
            doc.setFontSize(8);
            doc.text(`Page ${i} of ${pageCount}`, pageWidth - 20, pageHeight - 10, { align: 'right' });
        }


        doc.save('Order_Report.pdf');
    };

    const handleDownloadPdf = async () => {
        try {
            setIsLoadig(true);
            const response = await fetch(`${config.API_URL}/Report/order-pdf`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    fromdate: selectedFromDate,
                    todate: selectedToDate,
                    scp: (selectedscpName === '') ? "ALL" : selectedscpName || 'ALL',
                    dscp: selectedScpId || '',
                    type: selectedOrderType || '',
                    ORDIT_ProductID: (selectedProductName === null) ? "ALL" : selectedProductName || 'ALL',
                    ProductName: (selectedProductName === null) ? "ALL" : optionsproduct.find(option => option.value === selectedProductName)?.label || 'ALL',
                    SCPName: (selectedscpName === "ALL") ? "ALL" : (selectedscpName === null) ? "ALL" : scpoptions.find(option => option.value === selectedscpName)?.label || 'ALL',
                    UM_CompanyID,
                    UM_UserCode
                }),
            });

            // ❌ handle 404 / 500 properly
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // ✅ get PDF blob
            const blob = await response.blob();

            // ✅ download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Order_Report.pdf';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            toast.success('PDF downloaded successfully.',{onClose:()=> setIsLoadig(false)});


        } catch (error) {
            console.error('PDF download error:', error);
            toast.error('Failed to download PDF',{onClose:()=> setIsLoadig(false)});
        }
    };

    const addFooter = (doc) => {
        const totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            // Go to page i
            doc.setPage(i);

            // Set text alignment to left
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0); // Black color
            doc.text(
                "Developed by : Shubham Automation Pvt. Ltd.",
                10,
                doc.internal.pageSize.getHeight() - 10
            );
        }
    };
    const itemsPerPage = 10; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1);
    // Calculate total number of pages
    const totalPages = Math.ceil(Object.keys(auditData).length / itemsPerPage);
    // Function to handle page navigation
    const handlePageClick = (page) => {
        setCurrentPage(page);
    };
    // Logic to slice data based on current page
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedDataKeys = Object.keys(auditData).slice(startIndex, endIndex);
    const renderPagination = () => {
        const pages = [];
        const maxPagesToShow = 5; // Number of pages to show at a time
        const pageOffset = Math.floor((currentPage - 1) / maxPagesToShow) * maxPagesToShow;
        for (let i = 1 + pageOffset; i <= totalPages && i <= pageOffset + maxPagesToShow; i++) {
            pages.push(
                <li key={i} className={i === currentPage ? "page-item active" : "page-item"}>
                    <button className="page-linkd" onClick={() => handlePageClick(i)}>{i}</button>
                </li>
            );
        }
        return pages;
    };

    console.log(selectedscpName)

    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };
    const isValidDate = (date) => {
        const d = new Date(date);
        return d instanceof Date && !isNaN(d);
    };

    return (
        <>
            <ToastContainer
                            style={{
                                marginTop: '73px',
                                fontSize: '14px',
                                width: '40%',
                            }}
                        />

                  {isLoading && (
                <div style={{
                    position: 'fixed', // Sit on top of the page content
                    left: 0,
                    top: 0,
                    width: '100%', // Full width
                    height: '100%', // Full height

                    zIndex: 9999 // Sit on top of the other elements
                }} />
            )}
            
            <div className='main_container'>
                <h3 className='formHeading'>Order Report</h3>
                <div className='orderfilter-container'>
                    <div className='row align-items-space-betwee'>
                        <div className='col-md-3'>
                            <label>From</label>
                            <DatePicker
                                selected={selectedFromDate ? parse(selectedFromDate, 'dd/MM/yyyy', new Date()) : null}
                                onChange={(date) => {
                                    if (isValidDate(date)) {
                                        setSelectedFromDate(format(date, 'dd/MM/yyyy'));
                                        setfdate(format(date, 'dd/MM/yyyy'));
                                    }
                                }}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Select From Date"
                                className="form-control"
                                onKeyDown={handleKeyDown}
                            />

                        </div>
                        <div className='col-md-3'>
                            <label>To</label>
                            <DatePicker
                                selected={selectedToDate ? parse(selectedToDate, 'dd/MM/yyyy', new Date()) : null}
                                onChange={(date) => {
                                    if (isValidDate(date)) {
                                        setSelectedToDate(format(date, 'dd/MM/yyyy'));
                                        settdate(format(date, 'dd/MM/yyyy'));
                                    }
                                }}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="Select To Date"
                                className="form-control"
                                onKeyDown={handleKeyDown}
                            />
                        </div>
                        <div className='col-md-3'>
                            <label>Order Type  {showOrderTypeValidation && !selectedOrderType && (
                                <span style={{ color: 'red' }}>*</span>
                            )}</label>
                            <div className='select-container'>
                                <Select
                                    options={orderoption}
                                    onChange={handletypechange}
                                    placeholder="--Select--"
                                    className="routing_select-box"
                                    onMenuOpen={() => handleSelectOpen('orderoption')}
                                    onMenuClose={handleSelectClose}
                                    components={{ SingleValue: CustomSingleValue }}
                                />
                                <div className='icon-container'>
                                    {isSelectOpen === 'orderoption' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <label>SCP Name</label>
                            {scpoptions ? (
                                <div className='select-container'>
                                    <Select
                                        className='routing_select-box'
                                        value={scpoptions.find(option => option.value === selectedscpName)}
                                        onChange={handlescpChange}
                                        options={scpoptions}
                                        placeholder="--Select--"
                                        key={key} // Applying custom filter
                                        onMenuOpen={() => handleSelectOpen('selectedscpName')}
                                        onMenuClose={handleSelectClose}
                                        components={{ SingleValue: CustomSingleValue }}
                                        styles={{
                                            menuList: (base) => ({
                                                ...base,
                                                maxHeight: "150px",   // 👈 reduce dropdown height
                                            }),

                                        }}
                                    />
                                    <div className='icon-container'>
                                        {isSelectOpen === 'selectedscpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                    </div>
                                </div>
                            ) : (
                                <div className='select-container'>
                                    <Select
                                        className='routing_select-box'
                                        isDisabled
                                        placeholder="--Select--"
                                        onMenuOpen={() => handleSelectOpen('selectedscpName')}
                                        onMenuClose={handleSelectClose}
                                        components={{ SingleValue: CustomSingleValue }}
                                    />
                                    <div className='icon-container'>
                                        {isSelectOpen === 'selectedscpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                    </div>
                                </div>
                            )}

                        </div>
                        <div className='col-md-3 mt-2'>
                            <label>Product Name</label>
                            {scpoptions ? (
                                <div className='select-container'>
                                    <Select
                                        id="productName"
                                        className='routing_select-box'
                                        value={optionsproduct.find(option => option.value === selectedProductName)}
                                        onChange={handleChangeProductName}
                                        options={optionsproduct}
                                        placeholder="--Select--"
                                        filterOption={customFilter} // Applying custom filter
                                        onMenuOpen={() => handleSelectOpen('Product')}
                                        onMenuClose={handleSelectClose}
                                        components={{ SingleValue: CustomSingleValue }}
                                        styles={{
                                            menuList: (base) => ({
                                                ...base,
                                                maxHeight: "150px",   // 👈 reduce dropdown height
                                            }),

                                        }}
                                    />
                                    <div className='icon-container'>
                                        {isSelectOpen === 'Product' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                    </div>
                                </div>
                            ) : (
                                <div className='select-container'>
                                    <Select
                                        isDisabled
                                        className="routing_select-box"
                                        onMenuOpen={() => handleSelectOpen('Product')}
                                        onMenuClose={handleSelectClose}
                                        components={{ SingleValue: CustomSingleValue }}
                                        placeholder="--Select--"
                                    />
                                    <div className='icon-container'>
                                        {isSelectOpen === 'Product' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                    </div>
                                </div>
                            )}
                        </div >
                        <div className='col-md-2 mt-2 searchPrintContainer'>

                            <button
                                type="button"
                                onClick={handleSearch}
                                className="search_btn col-md-8"
                            >
                                SEARCH
                            </button>
                            {/* <img title='Print' className='orderprinticon ' src={Icon8} alt="icon" onClick={generatePDF} /> */}
                            {auditData.length > 0 && (
                                <button onClick={handleDownloadPdf}
                                    className='report_btn-OrderReport col-md-10'
                                    style={{ opacity: auditData.length === 0 ? 0.7 : 1, }}
                                    disabled={auditData.length === 0}>
                                    DOWNLOAD PDF
                                </button>
                            )}

                        </div>
                    </div >
                </div >

                {
                    loading ? (
                        <div></div >
                    ) : (
                        <div className='' ref={tableRef}>

                            <div className="ptable-wrapper">
                                <table className="ptableClass">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Order Number</th>
                                            <th>Order Date</th>
                                            <th>From SCP</th>
                                            <th>To SCP</th>
                                            <th>Product Name</th>
                                            <th>Product Code</th>
                                            <th>Quantity</th>
                                            <th>Order Type</th>
                                            <th>Created Date & Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(groupedAuditData).length > 0 ? (
                                            <>
                                                {paginatedDataKeys.map((key, index) => {
                                                    const order = auditData[key];
                                                    return (
                                                        <tr key={key}>
                                                            <td>{startIndex + index + 1}</td>
                                                            <td>{order.ORDM_OrderNumber}</td>
                                                            <td>{formatDateOnly(order.ORDM_OrderDate)}</td>
                                                            <td>{order.FromSCPM_Name}</td>
                                                            <td>{order.ToSCPM_Name}</td>
                                                            <td>
                                                                {optionsproduct.find(option => option.value === order.ORDIT_ProductID)?.label || 'N/A'}
                                                            </td>
                                                            <td>
                                                                {optionsproduct.find(option => option.value === order.ORDIT_ProductID)?.code || 'N/A'}
                                                            </td>
                                                            <td>{order.ORDIT_OrderQTY}</td>
                                                            <td>{order.ORDM_Type === 1 ? "New Order" : "Sampling"}</td>
                                                            <td>{formatDate(order.ORDIT_CreatedTimestamp)}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <tr>
                                                <td colSpan="10">No Records Found</td>
                                            </tr>

                                        )}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    )}
            </div >
            < ul className="pagination" >
                {/* First Page Button */}
                < li className={currentPage === 1 || totalPages === 0 ? "page-item disabled" : "page-item"}>
                    <button className="page-linkd" onClick={() => handlePageClick(1)} disabled={currentPage === 1 || totalPages === 0}>First</button>
                </li >

                {/* Previous Page Button */}
                < li className={currentPage === 1 || totalPages === 0 ? "page-item disabled" : "page-item"}>
                    <button className="page-linkd" onClick={() => handlePageClick(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>Previous</button>
                </li >
                {/* Render Page Numbers */}
                {totalPages > 0 && renderPagination()}

                {/* Next Page Button */}
                <li className={currentPage === totalPages || totalPages === 0 ? "page-item disabled" : "page-item"}>
                    <button className="page-linkd" onClick={() => handlePageClick(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>Next</button>
                </li>

                {/* Last Page Button */}
                <li className={currentPage === totalPages || totalPages === 0 ? "page-item disabled" : "page-item"}>
                    <button className="page-linkd" onClick={() => handlePageClick(totalPages)} disabled={currentPage === totalPages || totalPages === 0}>Last</button>
                </li>
            </ul >
        </>
    );
};
export default OrderReport;

